import type { components } from "@ishvaram/api-client";

import { apiRequest } from "./_fetch";

export type KaalSarpRequest = components["schemas"]["KaalSarpRequest"];
export type KaalSarpResponse = components["schemas"]["KaalSarpResponse"];

export async function checkKaalSarpDosh(data: KaalSarpRequest): Promise<KaalSarpResponse> {
  return apiRequest<KaalSarpResponse>(
    "/kaal-sarp",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    20_000
  );
}

/** Human-readable label for each Kaal Sarp sub-type. */
export const KAAL_SARP_SUBTYPE_LABELS: Record<
  NonNullable<KaalSarpResponse["sub_type"]>,
  string
> = {
  anant: "Anant Kaal Sarp Dosh (Rahu in 1st house)",
  kulik: "Kulik Kaal Sarp Dosh (Rahu in 2nd house)",
  vasuki: "Vasuki Kaal Sarp Dosh (Rahu in 3rd house)",
  shankhpal: "Shankhpal Kaal Sarp Dosh (Rahu in 4th house)",
  padma: "Padma Kaal Sarp Dosh (Rahu in 5th house)",
  mahapadma: "Mahapadma Kaal Sarp Dosh (Rahu in 6th house)",
  takshak: "Takshak Kaal Sarp Dosh (Rahu in 7th house)",
  karkotak: "Karkotak Kaal Sarp Dosh (Rahu in 8th house)",
  shankhchoor: "Shankhchoor Kaal Sarp Dosh (Rahu in 9th house)",
  ghatak: "Ghatak Kaal Sarp Dosh (Rahu in 10th house)",
  vishdhar: "Vishdhar Kaal Sarp Dosh (Rahu in 11th house)",
  sheshnag: "Sheshnag Kaal Sarp Dosh (Rahu in 12th house)",
};
